export const TEAM_SET_INITIAL_STATE = 'TEAM_SET_INITIAL_STATE';
export const TEAM_FIND_ALL = 'TEAM_FIND_ALL';
export const TEAM_VIEW = 'TEAM_VIEW';
